module.exports = __webpack_public_path__ + "static/logo-e8adfcccfad015ba062774ac558a0ffc.svg";